import {eventbus, eventBusEvents} from '@fiizy/utils'

import {Client} from '@fiizy/auth'

import {getUserDeviceHash} from "@fiizy/tracking";

function getDeviceId() {
  return getUserDeviceHash();
}

function getClientInfo() {
  return {
    device: {
      id: getDeviceId() || undefined,
    },
    client: {
      bundle_identifier: app.config.clientBundleIdentifier,
      version: "2.0.0"
    }
  }
}

const auth = new Client({
  apiUrl: app.config.apiUrl,
  clientData: getClientInfo,
})

const bus = eventbus(window.eventChannel || 'c432556660722ff93cefb5a932e550b7');
const { logOut, saveCredentials } = eventBusEvents

export let authToken = ''

export async function isUserAuth() {
    if (!(await auth.check())) {
        authToken = null
        return null;
    }

    const accessToken = auth.getAccessToken();

    if (accessToken) {
        bus.emit(saveCredentials, {});
        authToken = accessToken
        return accessToken;
    }

    authToken = null
    return null;
}

function showProfileLink(show) {
  const headerNavigation = document.getElementById('header-navigation')
    if (show) {
      headerNavigation.classList.add('logged-in')
    } else {
      headerNavigation.classList.remove('logged-in')
    }
}

async function initLogin() {
    showProfileLink(false);

    function goToProfile() {
        window.location = '/profile'
    }

    function goToLogin() {
        window.location = '/login'
    }

    const loginButton = document.querySelector('#login-button');
    if (loginButton) {
        loginButton.addEventListener('click', goToLogin)
    }

    const profileButton = document.querySelector('#profile-button');
    if (profileButton) {
        profileButton.addEventListener('click', goToProfile)
    }

    bus.on(saveCredentials, (payload) => {
        if (payload) {
            showProfileLink(true)
        }
    });
    bus.on(logOut, () => {
        showProfileLink(false)
    })
}


document.addEventListener('DOMContentLoaded', () => {
    initLogin().then(() => {
        isUserAuth();
    });
})
